module.exports = __webpack_public_path__ + "static/media/trailer.a7267fdf.svg";